import script from "./SettingMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SettingMenu.vue?vue&type=style&index=0&id=5b607666&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b607666"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
